var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseButton',{on:{"click":_vm.onPrintReceipt}},[_c('Icon',{staticClass:"h-4 w-4",attrs:{"icon":"heroicons:printer-solid"}}),_vm._v(" Cetak Surat Tanda Terima ")],1),(_vm.order)?_c('VueHtml2pdf',{ref:"printStockMovementEl",attrs:{"show-layout":false,"float-layout":true,"preview-modal":true,"enable-download":true,"paginate-elements-by-height":5000,"filename":_vm.filename,"pdf-quality":2,"manual-pagination":false,"pdf-format":"a4","pdf-orientation":"portrait","pdf-content-width":"210mm"}},[_c('LayoutPrintStockMovementReceipt',{attrs:{"slot":"pdf-content","display-per-product":"","details":_vm.movementDetails.data,"stock-movement":_vm.stockMovement.data,"order":{
        id: _vm.order.id,
        code: _vm.order.attributes.origin_code,
        date: _vm.order.attributes.orderedAt || _vm.order.attributes.createdAt,
        destinationOfficeCode: _vm.destinationOffice
          ? _vm.destinationOffice.attributes.code
          : '-',
        destinationOfficeName: _vm.destinationOffice
          ? _vm.destinationOffice.attributes.name
          : '-',
        destinationOfficeAddress: _vm.destinationOfficeAddress,
        orderAddress: _vm.orderAddress,
        type: _vm.orderType,
        shipmentType: _vm.order.attributes.order_shipment,
      }},slot:"pdf-content"})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }